import CtaLink from '@/components/CtaLink';
import CtaText from '@/components/CtaText';
import RightCheveron from '@/components/Icons/RightCheveron';
import ImageMarqueeCarousel from '@/components/ImageMarqueeCarousel';
import OnboardingHeader from '@/components/OnboardingHeader';
import PageLayout from '@/components/PageLayout';
import { NavBarLightTheme } from '@/components/PageLayout/PageNavBar';
import TwelveColGrid from '@/components/TwelveColGrid';
import {
  CLIENT_LOGIN_VIA_EMAIL_URL,
  CLIENT_PRIVACY_POLICY_URL,
  CLIENT_SIGNUP_VIA_EMAIL_URL,
  CLIENT_TERMS_AND_CONDITIONS_URL,
  defaultImageMarqueeCarouselImages,
} from '@/utils/constants';
import { genQs } from '@/utils/v2HelperMethods';
import { GetServerSideProps } from 'next';
import Link from 'next/link';

export default function SignUpPage({ redirect }: { redirect: string | null }) {
  const params = redirect ? genQs({ redirect }) : '';
  return (
    <PageLayout>
      <NavBarLightTheme sticky={false} />
      <TwelveColGrid my="mt-6.4 mb-8">
        <OnboardingHeader
          title="WELCOME BACK"
          subCopy="Do you already have an account?"
          ctaCopy="Login"
          ctaSrc={CLIENT_LOGIN_VIA_EMAIL_URL + params}
        />
      </TwelveColGrid>
      <div className="relative flex flex-col items-center">
        <ImageMarqueeCarousel imgUrlArray={defaultImageMarqueeCarouselImages} />
        <div className="pb-1.6 border-b border-black border-opacity-10 mb-10">
          <CtaLink
            width="w-34.4 lgt:w-36.0"
            height="h-4.8"
            href={CLIENT_SIGNUP_VIA_EMAIL_URL + params}
          >
            <CtaText>SIGN UP WITH EMAIL</CtaText>
            <RightCheveron />
          </CtaLink>
        </div>
        <span className="text-xs text-black-300">
          BY SIGNING UP, YOU AGREE TO{' '}
          <Link
            href={CLIENT_TERMS_AND_CONDITIONS_URL}
            className="text-black-100 mx-0.3 font-medium">
            T&amp;C&apos;S
          </Link>{' '}
          AND{' '}
          <Link
            href={CLIENT_PRIVACY_POLICY_URL}
            className="text-black-100 mx-0.3 font-medium">
            PRIVACY POLICY.
          </Link>
        </span>
      </div>
    </PageLayout>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  const { redirect = null } = query;
  return { props: { redirect } };
};
